import { create } from 'zustand'
import { persist } from 'zustand/middleware'

import { safeLocalStorage } from '~/store/safeLocalStorage'

const HIDDEN_DIGIT = '•'
// Four digits keep a masked amount close to the width of the values it replaces.
const HIDDEN_DIGITS_COUNT = 4
// Every currency amount renders two decimals, so the mask keeps them and
// reads as money rather than as a missing value. Token amounts have no
// fixed precision, so they use the digits alone.
const HIDDEN_DECIMALS_COUNT = 2

export const HIDDEN_DIGITS = HIDDEN_DIGIT.repeat(HIDDEN_DIGITS_COUNT)
export const HIDDEN_DECIMALS = HIDDEN_DIGIT.repeat(HIDDEN_DECIMALS_COUNT)
export const HIDDEN_CURRENCY_AMOUNT = `${HIDDEN_DIGITS}.${HIDDEN_DECIMALS}`
// Same shape as shortenAddress output (4 + 4 hex chars around an ellipsis),
// so a masked address keeps the width of the one it replaces.
export const HIDDEN_ADDRESS = '0x••••…••••'

interface PrivacyModeState {
  isPrivacyModeOn: boolean
  toggle: () => void
}

/**
 * Hides amounts and addresses. Device-scoped: the point is the screen being
 * shared, so the state must survive reloads on this browser and must not
 * follow the user elsewhere.
 */
export const usePrivacyModeStore = create<PrivacyModeState>()(
  persist(
    (set, get) => ({
      isPrivacyModeOn: false,
      toggle: () => set({ isPrivacyModeOn: !get().isPrivacyModeOn }),
    }),
    {
      name: 'privacy-mode',
      storage: safeLocalStorage,
      version: 1,
    },
  ),
)
